import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
import { debounce } from '@studiometa/js-toolkit/utils';

/**
 * Bottom Sticky component
 * @returns {void}
 */
export default class StickyBottom extends withBreakpointObserver(Base) {
  index = 0;

  /**
   * App config.
   * @returns {object}
   */
  static config = {
    name: 'StickyBottom',
    refs: ['banner', 'btn'],
    options: {
      activeBreakpoints: {
        type: String,
        default: 'xxs xs s',
      },
    },
  };

  /**
   * Debounced Add sticky
   * @type {null|Function}
   */
  debouncedAddSticky = null;

  /**
   * On mounted
   */
  mounted() {
    this.debouncedAddSticky = debounce(() => {
      this.$refs.banner.classList.add('banner--sticky');
    }, 450);
  }

  /**
   * Stock stickyBannerShown to don't repeat the task
   * @returns {object}
   */
  data() {
    return {
      stickyBannerShown: false,
    };
  }

  /**
   * When scroll show the banner
   * @param  {object} options
   * @param  {object} options.direction
   */
  scrolled({ direction }) {
    const stickyShowValue = Number.parseInt(this.$refs.banner.dataset.stickyshow, 10);

    if (Number.isNaN(stickyShowValue) || stickyShowValue < 0) {
      console.error('Invalid stickyShowValue:', stickyShowValue);
      return;
    }
    const scrollThreshold = document.documentElement.scrollHeight * (stickyShowValue / 100);
    const hasSticky = this.$refs.banner.classList.contains('banner--sticky');

    if (
      direction.y === 'DOWN' &&
      !hasSticky &&
      window.scrollY > scrollThreshold &&
      !this.stickyBannerShown
    ) {
      this.stickyBannerShown = true;
      this.debouncedAddSticky();
      this.showBannerStickyAfter();
      this.disableScroll();
    }
  }

  /**
   * Show an banner sticky after for a focus on th banner
   */
  showBannerStickyAfter() {
    const bannerStickyAfter = document.querySelector('.banner--sticky-after');
    if (bannerStickyAfter) {
      bannerStickyAfter.style.display = 'block';
      setTimeout(() => {
        bannerStickyAfter.style.opacity = '0.25';
      }, 100);
    }
  }

  /**
   * Hide the banner sticky after when closing the banner
   */
  hideBannerStickyAfter() {
    const bannerStickyAfter = document.querySelector('.banner--sticky-after');
    if (bannerStickyAfter) {
      bannerStickyAfter.style.opacity = '0';
      setTimeout(() => {
        bannerStickyAfter.style.display = 'none';
      }, 400);
    }
  }

  /**
   * disable scroll (for banner open)
   */
  disableScroll() {
    document.body.style.overflow = 'hidden';
    const closeButton = this.$refs.banner.querySelector('.banner--close');
    closeButton.addEventListener('click', this.closeBanner.bind(this));
  }

  /**
   * Get the closing button on the banner to close it
   * @param {Event} event
   */
  closeBanner(event) {
    event.preventDefault();
    this.enableScroll();
    this.$refs.banner.classList.remove('banner--sticky');
    this.hideBannerStickyAfter(); // Hide the sticky after banner on close
  }

  /**
   * Enable the scroll when user clicked on close
   */
  enableScroll() {
    document.body.style.overflow = '';
  }

  /**
   * Update values
   * @param  {string} url url to set
   * @returns {void}
   */
  updateValues(url) {
    this.$el.href = url;
  }

  /**
   * Check link before redirect
   * @param  {object} e current element.
   * @returns {void}
   */
  onClick(e) {
    if (this.$el.href.includes('web.may-care.fr') && this.$parent.mixpanelDistinctID) {
      e.preventDefault();
      window.location.href = `${this.$el.href}&distinct_id=${this.$parent.mixpanelDistinctID}`;
    }
  }
}
